import installationInstructions from './installationInstructions';

const pepOutletContent = {
  installationInstructions
}

export { pepOutletContent };
